import api from '@/plugins/api';
export default class {
  parent = null;

  seatingArrangements = [];
  seatingArrangementsSelected = [];
  transportName = ''
  columns = 0;
  rows = 0;
  showTransfer = false;
  transferId = 0;
  transportId = 0
  constructor(parent) {
    this.parent = parent;
  }

  clear() {
    this.seatingArrangements = [];
    this.seatingArrangementsSelected = [];
    this.transportName = ''
    this.columns = 0;
    this.rows = 0;
    this.showTransfer = false;
    this.transferId = 0;
    this.transportId = 0
  }

  set(data) {
    this.clear();

    const transfer = data.tourServices.find(x => x.serviceClass.id === 2);
    if (transfer == undefined) return false;
    if (transfer.transferData == undefined || transfer.transferData == null) return false;

    const trData = transfer.transferData;
    if (trData.transport == undefined || trData.transport == null) return false;
    this.transportId = trData.transport.value;
    this.transferId = trData.transfer.value;

    let reserveSeatingArrangement = [];
    if (data.seatingArrangementInfos != undefined && data.seatingArrangementInfos != null) {
      const d = data.seatingArrangementInfos.filter(item => {
        return item.transfer.value == this.transferId && item.transport.value == this.transportId
      });
      d.forEach((el) => {
        reserveSeatingArrangement.push(...el.seatingArrangements)
      });
    }
    this.getDictionary(reserveSeatingArrangement);
  }

  getDictionary(reserveSeatingArrangement) {
    return api.tour.transport(this.transportId)
      .then((data) => {
        return this.setSeatingArrangements(data.item, reserveSeatingArrangement);
      })
      .catch((er) => {
        console.log('error!', er);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  setSeatingArrangements(data, reserveSeatingArrangement) {
    if (!data.seatingArrangements.length) return false;
    this.showTransfer = true;
    let seatingArrangements = data.seatingArrangements;
    this.transportName = data.name;
    this.rows = data.rows;
    this.columns = data.columns;
    if(reserveSeatingArrangement.length){

      reserveSeatingArrangement.forEach((el) => {
        const seatingArrangement = seatingArrangements.find(item => { return item.id == el.id });
        if(seatingArrangement != undefined){
          seatingArrangements = seatingArrangements.filter(item1 => {return item1.id != el.id });
          seatingArrangement.type = 2;
          seatingArrangements.push(seatingArrangement)
        }
      });
    }
    this.seatingArrangements = seatingArrangements;
  }

  setActive(index) {
    const el = this.seatingArrangements[index];
    if (el.type == 3) {
      el.type = 13;
      this.seatingArrangementsSelected.push(el);
    } else {
      el.type = 3;
      this.seatingArrangementsSelected = this.seatingArrangementsSelected.filter(item => {
        return item.id != el.id
      })
    }
    this.seatingArrangements[index] = el;
  }

  checkSetActive(index,maxCount) {
    const el = this.seatingArrangements[index];
    if (el.type == 3) {
      if (maxCount > this.seatingArrangementsSelected.length)
        return true;
      else
        return false;
    } else {
      return true;
    }
  }

  checkCountTourists() {
    if(this.transportId == null || this.transportId == 0) return true;
    const parent = this.parent;
    const child = parseInt(parent.tariffs.child, 10);
    const adult = parseInt(parent.tariffs.adult, 10);
    return child + adult === this.seatingArrangementsSelected.length;
  }

  get data() {
    return {
      TransferId: this.transferId,
      TransportId: this.transportId,
      SeatingArrangements: this.seatingArrangementsSelected.map(i => (
        {
          Id: i.id,
          SeatNumber: i.seatNumber,
          Type: i.type,
          XCoord: i.xCoord,
          YCoord: i.yCoord,
        }))
    };
  }
}
